<mydocma-app-container [options]="options" class="mydocma">

  <div mydocma-header-item-left *ngIf="currentProjectIntegration && !isCustomerRoute" style="display: flex;">

    <!-- Desktop -->
    <img
      style="height: 30px;"
      *ngIf="(touchScreenDetectionService.mouseMode$ | async) || (!(touchScreenDetectionService.mouseMode$ | async) && deviceService.isDesktop()); else mobileHeaderItemLeft"
      [src]="currentProjectIntegration.Image"
      [matTooltip]="currentProjectIntegration.Name1"
      [matTooltipDisabled]="!currentProjectIntegration.Name1"
    />

    <!-- Mobile/Tablet -->
    <ng-template #mobileHeaderItemLeft>
      <div style="height: 40px; width: 40px; padding: 12px;" [matMenuTriggerFor]="menu">
        <mat-icon style="color: white; font-size: 16px;" class="material-icons-outlined">info</mat-icon>
      </div>
      <mat-menu #menu="matMenu" class="integration-menu">
        <div>
          <div *ngIf="currentProjectIntegration.Image" style="height: 30px; margin: 12px 16px;">
            <img style="height: 30px;" [src]="currentProjectIntegration.Image" />
          </div>
          <div style="height: 24px; margin: 12px 16px; display: flex; align-items: center;">
            <mat-icon style="color: #343E48; font-size: 24px; margin-right: 8px;" class="material-icons-outlined">info</mat-icon>
            {{ currentProjectIntegration.Name1 }}
          </div>
        </div>
      </mat-menu>
    </ng-template>
  </div>

  <div mydocma-header-item-right style="color: white">

    <div class="custom-tooltip-container" style="margin-top: 6px; margin-right: 10px; position: relative; display: inline-block; z-index: 2000">
      <mydocma-custom-mat-icon *ngIf="((this.currentFaultsSyncStateService.currentSyncState$ | async)?.isSyncing ?? false) == false
            && ((this.currentFaultsSyncStateService.currentSyncState$ | async)?.countWithSyncError ?? 0) == 0
            && ((this.currentFaultsSyncStateService.currentSyncState$ | async)?.countNotSynced ?? 0) > 0"
        [iconName]="'_warning-filled'"
        (click)="this.openFaultsSyncDialog()"
        style="color: orange">
      </mydocma-custom-mat-icon>

      <mydocma-custom-mat-icon *ngIf="((this.currentFaultsSyncStateService.currentSyncState$ | async)?.isSyncing ?? false) == false
            && ((this.currentFaultsSyncStateService.currentSyncState$ | async)?.countWithSyncError ?? 0) > 0"
        [iconName]="'_high-priority'"
        (click)="this.openFaultsSyncDialog()"
        style="color: red">
      </mydocma-custom-mat-icon>

      <mat-icon
        *ngIf="((this.currentFaultsSyncStateService.currentSyncState$ | async)?.isSyncing ?? false)"
        style="color: var(--mydocma-color-turquoise); animation: spin 2s infinite;"
        [matTooltip]="'MM.syncTooltip.uploading' | translate">sync
      </mat-icon>

      <!-- Warning tooltip -->
      <span
        *ngIf="((this.currentFaultsSyncStateService.currentSyncState$ | async)?.isSyncing ?? false) == false
          && ((this.currentFaultsSyncStateService.currentSyncState$ | async)?.countWithSyncError ?? 0) == 0
          && ((this.currentFaultsSyncStateService.currentSyncState$ | async)?.countNotSynced ?? 0) > 0"
        class="sync-tooltip">
        <span class="row">
          <span class="field">{{ 'MM.syncTooltip.uploadIncomplete' | translate }}</span>
          <span class="value">{{ (this.currentFaultsSyncStateService.currentSyncState$ | async)?.countNotSynced }}</span>
        </span>
      </span>

      <!-- Error tooltip -->
      <span
        *ngIf="((this.currentFaultsSyncStateService.currentSyncState$ | async)?.isSyncing ?? false) == false
          && ((this.currentFaultsSyncStateService.currentSyncState$ | async)?.countWithSyncError ?? 0) > 0"
        class="sync-tooltip">
        <span class="row">
          <span class="field">{{ 'MM.syncTooltip.error' | translate }}</span>
          <span class="value">{{ (this.currentFaultsSyncStateService.currentSyncState$ | async)?.countWithSyncError }}</span>
        </span>
        <span class="row">
          <span class="field">{{ 'MM.syncTooltip.uploadIncomplete' | translate }}</span>
          <span class="value">{{ (this.currentFaultsSyncStateService.currentSyncState$ | async)?.countNotSynced }}</span>
        </span>
      </span>

    </div>


  </div>
</mydocma-app-container>
